import React, { useState, useEffect, useMemo } from 'react';
import {
  Card,
  Button,
  Spin,
  Space,
  Modal,
  message,
  Popconfirm,
  Alert,
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery, gql, useLazyQuery, useMutation } from '@apollo/client';
// import {
//   EyeOutlined,
//   DeleteOutlined,
//   DownloadOutlined,
// } from '@ant-design/icons';
// import moment from 'moment';

import DataGrid from '../../components/DataGrid';
// import * as Config from '../../appConfig';
// import { activePeriod, disabledDate } from '../../utils/date';

import {
  // updateTableMetaData,
  updateGridMetaData,
  resetGridFilters,
} from '../../store/reducers/expenseSlice';
import { INCENTIVE_LIST_FIELDS } from '../../apollo/fragments';

const INCENTIVES_QUERY = gql`
  ${INCENTIVE_LIST_FIELDS}
  query GetIncentives(
    $first: Int
    $page: Int
    $filters: [QueryGetIncentivesFilter]
    $sort: QueryGetIncentivesSorter
  ) {
    incentives(first: $first, page: $page, filters: $filters, sort: $sort) {
      paginatorInfo {
        count
        currentPage
        total
      }
      data {
        ...IncentivesListFields
      }
    }
  }
`;

const Incentives = ({ gridId }) => {
  const { metaData, grids } = useSelector((state) => state.expense);
  const {
    user: { ability },
  } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const grid = grids.find((i) => i.id === gridId);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const queryVariables = useMemo(() => {
    return {
      first: grid.metaData.pagination.pageSize,
      page: grid.metaData.pagination.page,
      filters: grid.metaData.filters,
      sort: grid.metaData.sorting,
    };
  }, [
    grid.metaData.pagination.pageSize,
    grid.metaData.pagination.page,
    grid.metaData.filters,
    grid.metaData.sorting,
  ]);

  const { loading, data, error, refetch } = useQuery(INCENTIVES_QUERY, {
    variables: queryVariables,
  });

  console.log('ERROR', error);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  const columns = [
    {
      title: 'Sl.No',
      dataIndex: 'id',
      key: 'id',
      serverKey: 'ID',
      sorter: true,
      canExclude: false,
      visible: true,
      dataType: 'string',
      className: 'width-100',
    },
    {
      title: 'Import Id',
      dataIndex: 'import_id',
      key: 'import_id',
      serverKey: 'IMPORT_ID',
      sorter: true,
      canExclude: false,
      visible: true,
      dataType: 'string',
      className: 'width-100',
    },
    {
      title: 'Stage',
      dataIndex: ['stage', 'name'],
      key: 'stage',
      serverKey: 'STAGE',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
    },
    {
      title: 'Product',
      dataIndex: ['productType', 'name'],
      key: 'productType',
      serverKey: 'PRODUCT',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
    },
    {
      title: 'Portfolio',
      dataIndex: ['portfolio', 'name'],
      key: 'portfolio',
      serverKey: 'PORTFOLIO',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
    },
    {
      title: 'Bucket',
      dataIndex: 'bucket',
      key: 'bucket',
      serverKey: 'BUCKET',
      sorter: true,
      canExclude: false,
      visible: true,
      dataType: 'string',
      className: 'width-100',
    },
    {
      title: 'For Month',
      dataIndex: 'for_month',
      key: 'for_month',
      serverKey: 'MONTH',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'date',
      format: 'date',
    },
    {
      title: 'AM ID',
      dataIndex: ['am', 'emp_id'],
      key: 'am',
      serverKey: 'AM_ID',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
      // fixed: 'right',
    },
    {
      title: 'TL ID',
      dataIndex: ['tl', 'emp_id'],
      key: 'tl',
      serverKey: 'TL_ID',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
      // fixed: 'right',
    },
    {
      title: 'FE ID',
      dataIndex: ['fe', 'emp_id'],
      key: 'fe',
      serverKey: 'FE_ID',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
      // fixed: 'right',
    },
    {
      title: 'TL Incentive',
      dataIndex: 'tl_incentive',
      key: 'tl_incentive',
      serverKey: 'TL_INCENTIVE',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
      format: 'currency',
      className: 'cell-currency',
      // fixed: 'right',
    },
    {
      title: 'FE Incentive',
      dataIndex: 'fe_incentive',
      key: 'fe_incentive',
      serverKey: 'FE_INCENTIVE',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: true,
      dataType: 'string',
      format: 'currency',
      className: 'cell-currency',
      // fixed: 'right',
    },
    {
      title: 'Imported By',
      dataIndex: ['createdBy', 'name'],
      key: 'created_by',
      serverKey: 'USER',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: false,
      dataType: 'string',
      // fixed: 'right',
    },
    {
      title: 'Imported Date',
      dataIndex: 'created_at',
      key: 'created_at',
      serverKey: 'CREATED_AT',
      sorter: true,
      canExclude: false,
      visible: true,
      ellipsis: false,
      dataType: 'date',
      format: 'date',
      // fixed: 'right',
    },
  ];

  // const columnsForExport = [...columns];

  useEffect(() => {
    if (grid) {
      console.log('refetch for metaData with///', queryVariables);
      refetch(queryVariables);
    }
  }, [dispatch, refetch, grid, queryVariables]);

  const onChange = (updatedMetaData) => {
    console.log('onChange///', updatedMetaData);
    // dispatch(
    //   updateTableMetaData({
    //     metaData: {
    //       ...metaData,
    //       ...updatedMetaData,
    //     },
    //   })
    // );
    dispatch(
      updateGridMetaData({
        gridId,
        metaData: updatedMetaData,
      })
    );
  };

  return (
    <Spin spinning={loading}>
      <Card className="employeesCard" style={{ minHeight: '200px' }}>
        {/* {error && <Error message={error.message} />} */}

        {data && (
          <DataGrid
            dataSource={data.incentives.data}
            columns={columns}
            rowSelection={rowSelection}
            filters={grid.metaData.filters}
            visibleColumns={grid.metaData.visibleColumns}
            sorting={grid.metaData.sorting}
            pagination={grid.metaData.pagination}
            onChange={onChange}
            totalRecords={data.incentives.paginatorInfo.total}
            onClearFilter={() => {
              dispatch(resetGridFilters({ gridId }));
            }}
            scroll={{ x: 2000 }}
          />
        )}
      </Card>
    </Spin>
  );
};

export default Incentives;
